import * as React from "react"
export const GrabIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={16}
    className="stroke-fg-2"
    viewBox="0 0 10 16"
    fill="none"
    {...props}>
    <path
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="M7.833 2.167v.008m0 5.825v.008m0 5.825v.009m-6-11.675v.008m0 5.825v.008m0 5.825v.009M7.833 3a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Zm0 5.833a.833.833 0 1 1 0-1.666.833.833 0 0 1 0 1.666Zm0 5.834a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667ZM1.833 3a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Zm0 5.833a.833.833 0 1 1 0-1.666.833.833 0 0 1 0 1.666Zm0 5.834a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z"
    />
  </svg>
)
